import { render, staticRenderFns } from "./EventsIndex.vue?vue&type=template&id=1256dbd2&scoped=true&"
import script from "./EventsIndex.vue?vue&type=script&lang=js&"
export * from "./EventsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1256dbd2",
  null
  
)

export default component.exports